/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProxyProfileMini,
    ProxyProfileMiniFromJSON,
    ProxyProfileMiniFromJSONTyped,
    ProxyProfileMiniToJSON,
} from './';

/**
 * 
 * @export
 * @interface Proxy
 */
export interface Proxy {
    /**
     * 
     * @type {number}
     * @memberof Proxy
     */
    id: number;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof Proxy
     */
    readonly urls: { [key: string]: string | undefined; };
    /**
     * 
     * @type {ProxyProfileMini}
     * @memberof Proxy
     */
    profile: ProxyProfileMini;
    /**
     * 
     * @type {string}
     * @memberof Proxy
     */
    readonly failedReason: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Proxy
     */
    readonly skipped: boolean;
    /**
     * 
     * @type {string}
     * @memberof Proxy
     */
    readonly transforms: string;
    /**
     * 
     * @type {Date}
     * @memberof Proxy
     */
    readonly generated: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Proxy
     */
    generatedDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof Proxy
     */
    failed?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Proxy
     */
    failedCount?: number;
    /**
     * 
     * @type {string}
     * @memberof Proxy
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Proxy
     */
    variantId?: string;
    /**
     * 
     * @type {string}
     * @memberof Proxy
     */
    variantConfig?: string;
    /**
     * 
     * @type {number}
     * @memberof Proxy
     */
    asset: number;
}

export function ProxyFromJSON(json: any): Proxy {
    return ProxyFromJSONTyped(json, false);
}

export function ProxyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Proxy {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'urls': json['urls'],
        'profile': ProxyProfileMiniFromJSON(json['profile']),
        'failedReason': json['failed_reason'],
        'skipped': json['skipped'],
        'transforms': json['transforms'],
        'generated': (json['generated'] === null ? null : new Date(json['generated'])),
        'generatedDate': !exists(json, 'generated_date') ? undefined : (json['generated_date'] === null ? null : new Date(json['generated_date'])),
        'failed': !exists(json, 'failed') ? undefined : json['failed'],
        'failedCount': !exists(json, 'failed_count') ? undefined : json['failed_count'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'variantId': !exists(json, 'variant_id') ? undefined : json['variant_id'],
        'variantConfig': !exists(json, 'variant_config') ? undefined : json['variant_config'],
        'asset': json['asset'],
    };
}

export function ProxyToJSON(value?: Proxy | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'profile': ProxyProfileMiniToJSON(value.profile),
        'generated_date': value.generatedDate === undefined ? undefined : (value.generatedDate === null ? null : value.generatedDate.toISOString()),
        'failed': value.failed,
        'failed_count': value.failedCount,
        'name': value.name,
        'variant_id': value.variantId,
        'variant_config': value.variantConfig,
        'asset': value.asset,
    };
}


